/**
 * Happy Cysters — preserve brand terms under sitewide lowercase CSS.
 * See hc-lowercase-brand.css (.hc-pcos, .hc-brand-keep).
 */
(function () {
  const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'IFRAME', 'INPUT', 'SELECT', 'SVG', 'CODE', 'PRE']);

  /** @type {Array<[RegExp, string]>} Longest / most specific phrases first */
  const PHRASES = [
    [/\bWHO-GMP\s+Certified\b/gi, 'WHO-GMP Certified'],
    [/\bFSSAI\s+Licensed\b/gi, 'FSSAI Licensed'],
    [/\bJyoti\s+Wellness\s+Pvt\s+Ltd\.?\b/gi, 'Jyoti Wellness Pvt Ltd'],
    [/\bD-Chiro-Inositol\b/gi, 'D-Chiro-Inositol'],
    [/\bMyo-Inositol\b/gi, 'Myo-Inositol'],
    [/\bL-Methylfolate\b/gi, 'L-Methylfolate'],
    [/\bZinc\s+Bisglycinate\b/gi, 'Zinc Bisglycinate'],
    [/\bBlack\s+Pepper\b/gi, 'Black Pepper'],
    [/\bVitamin\s+D3\b/gi, 'Vitamin D3'],
    [/\bCystercare\b/gi, 'Cystercare'],
    [/\bShatavari\b/gi, 'Shatavari'],
    [/\bMoringa\b/gi, 'Moringa'],
    [/\bAmla\b/gi, 'Amla'],
    [/\bPCOS\b/gi, 'PCOS'],
    [/\bPCOD\b/gi, 'PCOD'],
  ];

  const TEST_RE = new RegExp(
    PHRASES.map(([re]) => re.source).join('|'),
    'i'
  );

  /** @param {Element | null} el */
  function skipElement(el) {
    if (!el || !(el instanceof Element)) return true;
    if (SKIP_TAGS.has(el.tagName)) return true;
    if (el.closest('.hc-pcos, .hc-brand-keep, .hc-natural-case')) return true;
    if (el.closest('[contenteditable="true"]')) return true;
    if (el.closest('.shopify-design-mode')) return true;
    return false;
  }

  /**
   * @param {string} text
   * @returns {DocumentFragment | null}
   */
  function buildFragment(text) {
    let working = text;
    const replacements = [];
    let changed = false;

    PHRASES.forEach(([re, replacement]) => {
      const localRe = new RegExp(re.source, re.flags);
      working = working.replace(localRe, (match) => {
        changed = true;
        const token = `\u0000${replacements.length}\u0000`;
        replacements.push({ display: replacement, raw: match });
        return token;
      });
    });

    if (!changed) return null;

    const frag = document.createDocumentFragment();
    const parts = working.split(/(\u0000\d+\u0000)/);
    parts.forEach((part) => {
      const tokenMatch = part.match(/^\u0000(\d+)\u0000$/);
      if (tokenMatch) {
        const item = replacements[Number(tokenMatch[1])];
        const span = document.createElement('span');
        span.className = item.display === 'PCOS' || item.display === 'PCOD' ? 'hc-pcos' : 'hc-brand-keep';
        if (item.display === 'D-Chiro-Inositol' || item.display === 'Myo-Inositol') {
          span.classList.add('hc-nowrap-ingredient');
        }
        span.textContent = item.display;
        frag.appendChild(span);
        return;
      }
      if (part) frag.appendChild(document.createTextNode(part));
    });
    return frag;
  }

  /** @param {Node} root */
  function processSubtree(root) {
    if (!(root instanceof Node)) return;
    if (root.nodeType === Node.ELEMENT_NODE && skipElement(root)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(textNode) {
        const parent = textNode.parentElement;
        if (!parent || skipElement(parent)) return NodeFilter.FILTER_REJECT;
        const v = textNode.nodeValue;
        if (!v || !TEST_RE.test(v)) return NodeFilter.FILTER_REJECT;
        TEST_RE.lastIndex = 0;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    const batch = [];
    let n = walker.nextNode();
    while (n) {
      batch.push(n);
      n = walker.nextNode();
    }

    batch.forEach((textNode) => {
      const text = textNode.nodeValue || '';
      const frag = buildFragment(text);
      if (!frag || !textNode.parentNode) return;
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  function run() {
    if (document.body) processSubtree(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  let debounceTimer;
  const mo = new MutationObserver((records) => {
    const roots = new Set();
    for (const r of records) {
      r.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) roots.add(node);
      });
    }
    if (!roots.size) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      roots.forEach(processSubtree);
    }, 120);
  });

  if (document.body) {
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
